module.exports = function (store, i18n) {
  return [
    {
      path: '/chapter1',
      config: {
        jumbotronPicture: store.state.route.fullPath.indexOf('limit-selector') !== -1 ? require('static/limits_break.jpg') : require('static/chapter1_break.jpg'),
        header: () => store.state.user.alternativeFlow ? i18n.t('enterCash:flying_bold_header') : i18n.t('enterCash:flying_bold_header_later'),
        steps: store.state.user.alternativeFlow ? [
          { title: () => i18n.t('enterCash:flying_step_1') },
          { title: () => i18n.t('enterCash:flying_step_2') },
          { title: () => i18n.t('enterCash:flying_step_3') }
        ] : [
          { title: () => i18n.t('enterCash:flying_step_1_later') },
          { title: () => i18n.t('enterCash:flying_step_2_later') },
          { title: () => i18n.t('enterCash:flying_step_3_later') }
        ]
      }
    },
    {
      path: '/chapter2',
      config: {
        jumbotronPicture: require('static/chapter2_break.jpg'),
        header: () => store.state.app.amountError ? i18n.t('enterCash:repeat_title_bold') : i18n.t('enterCash:happy_title_bold'),
        steps: [
          { title: () => i18n.t('enterCash:happy_step_1') },
          { title: () => i18n.t('enterCash:happy_step_2') },
          { title: () => i18n.t('enterCash:happy_step_3') }
        ]
      }
    },
    {
      path: '/chapter3',
      config: store.state.transactionInfo.orderStatus === 'OK' ? {
        jumbotronPicture: require('static/chapter3_break.jpg'),
        header: (store) => i18n.t('enterCash:rainbow_text', { amount: store.state.transactionInfo.amount }),
        steps: [
          { title: () => i18n.t('enterCash:rainbow_step_1') },
          { title: () => i18n.t('enterCash:rainbow_step_2') },
          { title: () => i18n.t('enterCash:rainbow_step_3') }
        ]
      } : {
        jumbotronPicture: require('static/chapter3_break.jpg'),
        header: (store) => i18n.t('enterCash:rainbow_text_deposit_later'),
        steps: [
          { title: () => i18n.t('enterCash:rainbow_step_1_deposit_later') },
          { title: () => i18n.t('enterCash:rainbow_step_2_deposit_later') },
          { title: () => i18n.t('enterCash:rainbow_step_3_deposit_later') }
        ]
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/partners/flow/chaptersPreScreensConfig.js